// navigation.service.ts
// import { Component, Injectable } from '@angular/core';
// import { Router, NavigationEnd } from '@angular/router';
import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class NavigationService {
  private history: string[] = [];

  constructor(private router: Router) {
    // Subscribe to navigation events and track history

    this.trackNavigation();

}


  private trackNavigation() {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: any) => {
        const ignoredRoutes = ['/login', '/popup']; // Define ignored pages
        if (!ignoredRoutes.includes(event.urlAfterRedirects)) {
          if (this.history.length === 0 || this.history[this.history.length - 1] !== event.urlAfterRedirects) {
            this.history.push(event.urlAfterRedirects);
          }
        }
      });
  }


  // Get the last visited page
//   getPreviousUrl(): string | null {
//     if (this.history.length > 1) {
//       return this.history[this.history.length - 2]; // Get the page before the current one
//     }
//     return null;
//   }


  public getPreviousUrl(): string | null {
    this.history.pop(); // Remove the current page
    return this.history.length > 0 ? this.history[this.history.length - 1] : null;
  }

  public clearHistory() {
    this.history = [];
  }
  

  // Handle back navigation programmatically
  navigateBack(): void {
    console.log('Navigating back...',this.history);
    this.history.pop(); // Remove the current page from history
    const previousUrl = this.getPreviousUrl();
    if (previousUrl) {
      this.router.navigateByUrl(previousUrl);
    } else {
      this.router.navigate(['/home']); // Default to home if no history
    }
  }
}